import hearticon from "../assets/logo/heart_7433689.png"
import brain from '../assets/logo/brain_9086054.png'
import cancer from '../assets/logo/clipboard_2871574.png'
import baby from '../assets/logo/baby-weight_15309704 (1).png'


export const WardsData = [
    {
        wardName: 'Cardiology',
        location: 'East Wing, 3rd Floor',
        headDoctor: 'Dr. Elizabeth Stone',

        logo: hearticon,
        
        requestDockerNo: "D12345",
        issueDate: "2024-11-25",
        requestDate: "2024-11-25",
        staff: [
          { name: 'Dr. John Doe', role: 'Cardiologist' },
          { name: 'Nurse Jane Smith', role: 'Nurse' },
          { name: 'Technician Mark Lee', role: 'Cardiac Technician' }
        ],
        medicines: [
          { name: 'Aspirin', stockLevel: 0, issueQuantity: 2, batchNumber: 'A123', expiryDate: '2026-06-12', ratePerUnit: 20, cost: 40 },
          { name: 'Atorvastatin', stockLevel: 1, issueQuantity: 1, batchNumber: 'B456', expiryDate: '2024-12-15', ratePerUnit: 35, cost: 35 },
          { name: 'Clopidogrel', stockLevel: 3, issueQuantity: 3, batchNumber: 'C789', expiryDate: '2026-05-20', ratePerUnit: 15, cost: 45 },
          { name: 'Lisinopril', stockLevel: 0, issueQuantity: 0, batchNumber: 'D321', expiryDate: '2025-07-01', ratePerUnit: 18, cost: 0 },
          { name: 'Furosemide', stockLevel: 1, issueQuantity: 1, batchNumber: 'E654', expiryDate: '2026-09-25', ratePerUnit: 10, cost: 10 },
          { name: 'Metoprolol', stockLevel: 2, issueQuantity: 2, batchNumber: 'F987', expiryDate: '2025-12-10', ratePerUnit: 25, cost: 50 },
          { name: 'Digoxin', stockLevel: 0, issueQuantity: 0, batchNumber: 'G123', expiryDate: '2025-05-15', ratePerUnit: 30, cost: 0 },
        ],
        inventory: [
          {
            name: 'Aspirin',
            stockLevel: 0,
            batchNumber: 'A123',
            expiryDate: '2024-12-14',
            ratePerUnit: 20,
            cost: 40,
            description: 'Aspirin is used to reduce fever, pain, and inflammation.',
            company: 'Bayer',
            tags: ['pain', 'fever', 'inflammation']
          },
          {
            name: 'Atorvastatin',
            stockLevel: 1,
            batchNumber: 'B456',
            expiryDate: '2024-12-15',
            ratePerUnit: 35,
            cost: 35,
            description: 'Atorvastatin is used to lower cholesterol and triglyceride levels in the blood.',
            company: 'Pfizer',
            tags: ['cholesterol', 'heart disease']
          },
          {
            name: 'Clopidogrel',
            stockLevel: 6,
            batchNumber: 'C789',
            expiryDate: '2026-05-20',
            ratePerUnit: 15,
            cost: 45,
            description: 'Clopidogrel is used to prevent blood clots, reducing the risk of stroke or heart attack.',
            company: 'Sanofi',
            tags: ['blood thinner', 'stroke', 'heart attack']
          },
          {
            name: 'Lisinopril',
            stockLevel: 0,
            batchNumber: 'D321',
            expiryDate: '2025-07-01',
            ratePerUnit: 18,
            cost: 0,
            description: 'Lisinopril is an ACE inhibitor used to treat high blood pressure and heart failure.',
            company: 'Merck',
            tags: ['blood pressure', 'heart failure']
          },
          {
            name: 'Furosemide',
            stockLevel: 1,
            batchNumber: 'E654',
            expiryDate: '2026-09-25',
            ratePerUnit: 10,
            cost: 10,
            description: 'Furosemide is a diuretic used to treat fluid retention and swelling caused by conditions like heart failure.',
            company: 'Lilly',
            tags: ['diuretic', 'fluid retention']
          },
          {
            name: 'Metoprolol',
            stockLevel: 4,
            batchNumber: 'F987',
            expiryDate: '2025-12-10',
            ratePerUnit: 25,
            cost: 50,
            description: 'Metoprolol is a beta-blocker used to treat high blood pressure and prevent heart attacks.',
            company: 'AstraZeneca',
            tags: ['blood pressure', 'heart attack prevention']
          },
          {
            name: 'Digoxin',
            stockLevel: 0,
            batchNumber: 'G123',
            expiryDate: '2025-05-15',
            ratePerUnit: 30,
            cost: 0,
            description: 'Digoxin is used to treat heart failure and atrial fibrillation.',
            company: 'Bristol-Myers Squibb',
            tags: ['heart failure', 'atrial fibrillation']
          },
          {
            name: 'Amlodipine',
            stockLevel: 15,
            batchNumber: 'H456',
            expiryDate: '2026-03-20',
            ratePerUnit: 22,
            cost: 22,
            description: 'Amlodipine is used to treat high blood pressure and chest pain (angina).',
            company: 'Pfizer',
            tags: ['blood pressure', 'angina']
          },
          {
            name: 'Heparin',
            stockLevel: 20,
            batchNumber: 'I789',
            expiryDate: '2026-01-14',
            ratePerUnit: 100,
            cost: 0,
            description: 'Heparin is an anticoagulant used to prevent blood clots.',
            company: 'Sanofi',
            tags: ['blood thinner', 'clot prevention']
          },
          {
            name: 'Warfarin',
            stockLevel: 24,
            batchNumber: 'J012',
            expiryDate: '2026-04-05',
            ratePerUnit: 50,
            cost: 50,
            description: 'Warfarin is used to prevent blood clots in the veins and arteries.',
            company: 'Bristol-Myers Squibb',
            tags: ['blood thinner', 'clot prevention']
          },
          {
            name: 'Nitroglycerin',
            stockLevel: 30,
            batchNumber: 'K345',
            expiryDate: '2025-01-01',
            ratePerUnit: 60,
            cost: 120,
            description: 'Nitroglycerin is used to prevent and treat chest pain (angina).',
            company: 'Novartis',
            tags: ['angina', 'chest pain']
          },
          {
            name: 'Statins',
            stockLevel: 18,
            batchNumber: 'L678',
            expiryDate: '2026-07-20',
            ratePerUnit: 40,
            cost: 160,
            description: 'Statins are used to lower cholesterol levels and reduce the risk of cardiovascular diseases.',
            company: 'AstraZeneca',
            tags: ['cholesterol', 'cardiovascular diseases']
          },
          {
            name: 'Dabigatran',
            stockLevel: 33,
            batchNumber: 'M901',
            expiryDate: '2026-05-28',
            ratePerUnit: 90,
            cost: 90,
            description: 'Dabigatran is an anticoagulant used to prevent blood clots and stroke in patients with atrial fibrillation.',
            company: 'Boehringer Ingelheim',
            tags: ['blood thinner', 'stroke prevention']
          }
        ],
        DrugConsumption : 
        [ 
          {
          
            "patientId": "P001",
            "patientName": "John Doe",
            "dob": "1985-06-15",
            "age": 39,
            "gender": "Male",
            "diagnosis": "Hypertension, High Cholesterol",
            "admissionDate": "2024-11-01",
            "dischargeDate": "2024-11-15",
            "medications": [
              {
                "medicationName": "Aspirin",
                "prescribedQuantity": 2,
                "consumedQuantity": 2,
                "issueQuantity": 2,
                "batchNumber": "A123",
                "expiryDate": "2026-06-12",
                "ratePerUnit": 20,
                "totalCost": 40,
                "medicationDescription": "Aspirin is used to reduce fever, pain, and inflammation.",
                "company": "Bayer",
                "tags": ["pain", "fever", "inflammation"],
                "shortage": true
              },
              {
                "medicationName": "Atorvastatin",
                "prescribedQuantity": 1,
                "consumedQuantity": 1,
                "issueQuantity": 1,
                "batchNumber": "B456",
                "expiryDate": "2025-08-15",
                "ratePerUnit": 35,
                "totalCost": 35,
                "medicationDescription": "Atorvastatin is used to lower cholesterol and triglyceride levels.",
                "company": "Pfizer",
                "tags": ["cholesterol", "heart disease"],
                "shortage": false
              },
              {
                "medicationName": "Metoprolol",
                "prescribedQuantity": 2,
                "consumedQuantity": 2,
                "issueQuantity": 2,
                "batchNumber": "F987",
                "expiryDate": "2025-12-10",
                "ratePerUnit": 25,
                "totalCost": 50,
                "medicationDescription": "Metoprolol is a beta-blocker used to treat high blood pressure.",
                "company": "AstraZeneca",
                "tags": ["blood pressure", "heart attack prevention"],
                "shortage": false
              }
            ]
          },
          
          {
            "patientId": "P002",
            "patientName": "Jane Smith",
            "dob": "1970-03-20",
            "age": 54,
            "gender": "Female",
            "diagnosis": "Heart Failure",
            "admissionDate": "2024-11-10",
            "dischargeDate": "2024-11-20",
            "medications": [
              {
                "medicationName": "Furosemide",
                "prescribedQuantity": 3,
                "consumedQuantity": 3,
                "issueQuantity": 1,
                "batchNumber": "E654",
                "expiryDate": "2026-09-25",
                "ratePerUnit": 10,
                "totalCost": 30,
                "medicationDescription": "Furosemide is a diuretic used to treat fluid retention and swelling.",
                "company": "Lilly",
                "tags": ["diuretic", "fluid retention"],
                "shortage": true
              },
              {
                "medicationName": "Lisinopril",
                "prescribedQuantity": 2,
                "consumedQuantity": 2,
                "issueQuantity": 0,
                "batchNumber": "D321",
                "expiryDate": "2025-07-01",
                "ratePerUnit": 18,
                "totalCost": 36,
                "medicationDescription": "Lisinopril is an ACE inhibitor used to treat high blood pressure.",
                "company": "Merck",
                "tags": ["blood pressure", "heart failure"],
                "shortage": true
              }
            ]
          },
          {
            "patientId": "P003",
            "patientName": "Alice Brown",
            "dob": "1992-09-05",
            "age": 32,
            "gender": "Female",
            "diagnosis": "Asthma",
            "admissionDate": "2024-11-05",
            "dischargeDate": "2024-11-20",
            "medications": [
              {
                "medicationName": "Albuterol",
                "prescribedQuantity": 4,
                "consumedQuantity": 4,
                "issueQuantity": 4,
                "batchNumber": "A123",
                "expiryDate": "2026-04-15",
                "ratePerUnit": 10,
                "totalCost": 40,
                "medicationDescription": "Albuterol is a bronchodilator used to relieve symptoms of asthma.",
                "company": "GlaxoSmithKline",
                "tags": ["asthma", "bronchodilator"],
                "shortage": false
              },
              {
                "medicationName": "Prednisone",
                "prescribedQuantity": 3,
                "consumedQuantity": 3,
                "issueQuantity": 3,
                "batchNumber": "B234",
                "expiryDate": "2025-12-01",
                "ratePerUnit": 5,
                "totalCost": 15,
                "medicationDescription": "Prednisone is a corticosteroid used to reduce inflammation.",
                "company": "Bristol-Myers",
                "tags": ["inflammation", "steroid"],
                "shortage": true
              }
            ]
          },
          
          // New patient P004 (Admitted on 2024-11-12, discharged on 2024-11-18)
          {
            "patientId": "P004",
            "patientName": "Robert Green",
            "dob": "1980-12-22",
            "age": 43,
            "gender": "Male",
            "diagnosis": "Diabetes",
            "admissionDate": "2024-11-12",
            "dischargeDate": "2024-11-18",
            "medications": [
              {
                "medicationName": "Metformin",
                "prescribedQuantity": 4,
                "consumedQuantity": 4,
                "issueQuantity": 4,
                "batchNumber": "C567",
                "expiryDate": "2025-09-30",
                "ratePerUnit": 15,
                "totalCost": 60,
                "medicationDescription": "Metformin is used to control blood sugar levels in type 2 diabetes.",
                "company": "Merck",
                "tags": ["diabetes", "blood sugar control"],
                "shortage": false
              }
            ]
          },
          {
            "patientId": "P005",
            "patientName": "Martha Black",
            "dob": "1965-04-10",
            "age": 59,
            "gender": "Female",
            "diagnosis": "Chronic Obstructive Pulmonary Disease (COPD)",
            "admissionDate": "2024-11-28",
            "dischargeDate": "2024-11-30",
            "medications": [
              {
                "medicationName": "Ipratropium",
                "prescribedQuantity": 2,
                "consumedQuantity": 2,
                "issueQuantity": 2,
                "batchNumber": "D890",
                "expiryDate": "2025-05-05",
                "ratePerUnit": 30,
                "totalCost": 60,
                "medicationDescription": "Ipratropium is an anticholinergic used to treat COPD symptoms.",
                "company": "Boehringer Ingelheim",
                "tags": ["COPD", "respiratory"],
                "shortage": false
              }
            ]
          }
        ]
      },


      
    {
        wardName: 'Neurology',
        location: 'West Wing, 2nd Floor',
        headDoctor: 'Dr. Samantha Green',
        
      logo: brain,
        requestDockerNo: "D12345",
        issueDate: "2024-11-25",
        requestDate: "2024-11-25",
        staff: [
            { name: 'Dr. Alan Williams', role: 'Neurologist' },
            { name: 'Nurse Olivia Johnson', role: 'Nurse' },
            { name: 'Technician Greg Black', role: 'Neuro Technician' }
        ],
        medicines: [
            { name: 'Lamotrigine', stockLevel: 0, issueQuantity: 2, batchNumber: 'N123', expiryDate: '2027-03-11', ratePerUnit: 40, cost: 80 },
            { name: 'Gabapentin', stockLevel: 1, issueQuantity: 1, batchNumber: 'O456', expiryDate: '2025-12-20', ratePerUnit: 25, cost: 25 },
            { name: 'Topiramate', stockLevel: 3, issueQuantity: 3, batchNumber: 'P789', expiryDate: '2026-08-15', ratePerUnit: 30, cost: 90 },
            { name: 'Carbamazepine', stockLevel: 0, issueQuantity: 0, batchNumber: 'Q321', expiryDate: '2025-07-18', ratePerUnit: 18, cost: 0 },
            { name: 'Valproate', stockLevel: 1, issueQuantity: 1, batchNumber: 'R654', expiryDate: '2026-04-10', ratePerUnit: 22, cost: 22 },
            { name: 'Baclofen', stockLevel: 2, issueQuantity: 2, batchNumber: 'S987', expiryDate: '2025-10-05', ratePerUnit: 15, cost: 30 },
            { name: 'Clonazepam', stockLevel: 0, issueQuantity: 0, batchNumber: 'T123', expiryDate: '2025-01-25', ratePerUnit: 28, cost: 0 },
        ],
        inventory: [
            {
                name: 'Lamotrigine',
                stockLevel: 0,
                batchNumber: 'N123',
                expiryDate: '2027-03-11',
                ratePerUnit: 40,
                cost: 80,
                description: 'Lamotrigine is used to treat epilepsy and bipolar disorder.',
                company: 'GlaxoSmithKline',
                tags: ['epilepsy', 'bipolar disorder']
            },
            {
                name: 'Gabapentin',
                stockLevel: 1,
                batchNumber: 'O456',
                expiryDate: '2025-12-20',
                ratePerUnit: 25,
                cost: 25,
                description: 'Gabapentin is used to treat nerve pain and seizures.',
                company: 'Pfizer',
                tags: ['nerve pain', 'seizures']
            },
            {
                name: 'Topiramate',
                stockLevel: 3,
                batchNumber: 'P789',
                expiryDate: '2026-08-15',
                ratePerUnit: 30,
                cost: 90,
                description: 'Topiramate is used to prevent and treat seizures and migraines.',
                company: 'Johnson & Johnson',
                tags: ['seizures', 'migraines']
            },
            {
                name: 'Carbamazepine',
                stockLevel: 0,
                batchNumber: 'Q321',
                expiryDate: '2025-07-18',
                ratePerUnit: 18,
                cost: 0,
                description: 'Carbamazepine is used to treat epilepsy and trigeminal neuralgia.',
                company: 'Novartis',
                tags: ['epilepsy', 'neuralgia']
            },
            {
                name: 'Valproate',
                stockLevel: 1,
                batchNumber: 'R654',
                expiryDate: '2026-04-10',
                ratePerUnit: 22,
                cost: 22,
                description: 'Valproate is used to treat epilepsy, bipolar disorder, and migraines.',
                company: 'AbbVie',
                tags: ['epilepsy', 'bipolar disorder', 'migraines']
            },
            {
                name: 'Baclofen',
                stockLevel: 2,
                batchNumber: 'S987',
                expiryDate: '2025-10-05',
                ratePerUnit: 15,
                cost: 30,
                description: 'Baclofen is used to relieve muscle spasms and spasticity.',
                company: 'Mylan',
                tags: ['muscle spasms', 'spasticity']
            },
            {
                name: 'Clonazepam',
                stockLevel: 0,
                batchNumber: 'T123',
                expiryDate: '2025-01-25',
                ratePerUnit: 28,
                cost: 0,
                description: 'Clonazepam is used to treat anxiety, panic attacks, and seizures.',
                company: 'Roche',
                tags: ['anxiety', 'panic attacks', 'seizures']
            },
            {
                name: 'Memantine',
                stockLevel: 12,
                batchNumber: 'U456',
                expiryDate: '2026-02-20',
                ratePerUnit: 50,
                cost: 600,
                description: 'Memantine is used to treat moderate to severe Alzheimer\'s disease.',
                company: 'Lilly',
                tags: ['Alzheimer\'s', 'dementia']
            },
            {
                name: 'Rivastigmine',
                stockLevel: 15,
                batchNumber: 'V789',
                expiryDate: '2025-12-30',
                ratePerUnit: 40,
                cost: 600,
                description: 'Rivastigmine is used to treat Alzheimer\'s disease and Parkinson\'s disease dementia.',
                company: 'Novartis',
                tags: ['Alzheimer\'s', 'Parkinson\'s disease']
            },
            {
                name: 'Lisdexamfetamine',
                stockLevel: 20,
                batchNumber: 'W012',
                expiryDate: '2026-07-15',
                ratePerUnit: 60,
                cost: 1200,
                description: 'Lisdexamfetamine is used to treat attention-deficit hyperactivity disorder (ADHD).',
                company: 'Shire',
                tags: ['ADHD']
            },
            {
                name: 'Dexmethylphenidate',
                stockLevel: 30,
                batchNumber: 'X345',
                expiryDate: '2026-09-05',
                ratePerUnit: 55,
                cost: 1650,
                description: 'Dexmethylphenidate is used to treat ADHD.',
                company: 'UCB',
                tags: ['ADHD']
            },
            
        ],

        DrugConsumption : 
        [ 
          {
          
            "patientId": "P001",
            "patientName": "John Doe",
            "dob": "1985-06-15",
            "age": 39,
            "gender": "Male",
            "diagnosis": "Hypertension, High Cholesterol",
            "admissionDate": "2024-11-01",
            "dischargeDate": "2024-11-15",
            "medications": [
              {
                "medicationName": "Aspirin",
                "prescribedQuantity": 2,
                "consumedQuantity": 2,
                "issueQuantity": 2,
                "batchNumber": "A123",
                "expiryDate": "2026-06-12",
                "ratePerUnit": 20,
                "totalCost": 40,
                "medicationDescription": "Aspirin is used to reduce fever, pain, and inflammation.",
                "company": "Bayer",
                "tags": ["pain", "fever", "inflammation"],
                "shortage": true
              },
              {
                "medicationName": "Atorvastatin",
                "prescribedQuantity": 1,
                "consumedQuantity": 1,
                "issueQuantity": 1,
                "batchNumber": "B456",
                "expiryDate": "2025-08-15",
                "ratePerUnit": 35,
                "totalCost": 35,
                "medicationDescription": "Atorvastatin is used to lower cholesterol and triglyceride levels.",
                "company": "Pfizer",
                "tags": ["cholesterol", "heart disease"],
                "shortage": false
              },
              {
                "medicationName": "Metoprolol",
                "prescribedQuantity": 2,
                "consumedQuantity": 2,
                "issueQuantity": 2,
                "batchNumber": "F987",
                "expiryDate": "2025-12-10",
                "ratePerUnit": 25,
                "totalCost": 50,
                "medicationDescription": "Metoprolol is a beta-blocker used to treat high blood pressure.",
                "company": "AstraZeneca",
                "tags": ["blood pressure", "heart attack prevention"],
                "shortage": false
              }
            ]
          },
          
          {
            "patientId": "P002",
            "patientName": "Jane Smith",
            "dob": "1970-03-20",
            "age": 54,
            "gender": "Female",
            "diagnosis": "Heart Failure",
            "admissionDate": "2024-11-10",
            "dischargeDate": "2024-11-20",
            "medications": [
              {
                "medicationName": "Furosemide",
                "prescribedQuantity": 3,
                "consumedQuantity": 3,
                "issueQuantity": 1,
                "batchNumber": "E654",
                "expiryDate": "2026-09-25",
                "ratePerUnit": 10,
                "totalCost": 30,
                "medicationDescription": "Furosemide is a diuretic used to treat fluid retention and swelling.",
                "company": "Lilly",
                "tags": ["diuretic", "fluid retention"],
                "shortage": true
              },
              {
                "medicationName": "Lisinopril",
                "prescribedQuantity": 2,
                "consumedQuantity": 2,
                "issueQuantity": 0,
                "batchNumber": "D321",
                "expiryDate": "2025-07-01",
                "ratePerUnit": 18,
                "totalCost": 36,
                "medicationDescription": "Lisinopril is an ACE inhibitor used to treat high blood pressure.",
                "company": "Merck",
                "tags": ["blood pressure", "heart failure"],
                "shortage": true
              }
            ]
          },
          {
            "patientId": "P003",
            "patientName": "Alice Brown",
            "dob": "1992-09-05",
            "age": 32,
            "gender": "Female",
            "diagnosis": "Asthma",
            "admissionDate": "2024-11-05",
            "dischargeDate": "2024-11-20",
            "medications": [
              {
                "medicationName": "Albuterol",
                "prescribedQuantity": 4,
                "consumedQuantity": 4,
                "issueQuantity": 4,
                "batchNumber": "A123",
                "expiryDate": "2026-04-15",
                "ratePerUnit": 10,
                "totalCost": 40,
                "medicationDescription": "Albuterol is a bronchodilator used to relieve symptoms of asthma.",
                "company": "GlaxoSmithKline",
                "tags": ["asthma", "bronchodilator"],
                "shortage": false
              },
              {
                "medicationName": "Prednisone",
                "prescribedQuantity": 3,
                "consumedQuantity": 3,
                "issueQuantity": 3,
                "batchNumber": "B234",
                "expiryDate": "2025-12-01",
                "ratePerUnit": 5,
                "totalCost": 15,
                "medicationDescription": "Prednisone is a corticosteroid used to reduce inflammation.",
                "company": "Bristol-Myers",
                "tags": ["inflammation", "steroid"],
                "shortage": true
              }
            ]
          },
          
          // New patient P004 (Admitted on 2024-11-12, discharged on 2024-11-18)
          {
            "patientId": "P004",
            "patientName": "Robert Green",
            "dob": "1980-12-22",
            "age": 43,
            "gender": "Male",
            "diagnosis": "Diabetes",
            "admissionDate": "2024-11-12",
            "dischargeDate": "2024-11-18",
            "medications": [
              {
                "medicationName": "Metformin",
                "prescribedQuantity": 4,
                "consumedQuantity": 4,
                "issueQuantity": 4,
                "batchNumber": "C567",
                "expiryDate": "2025-09-30",
                "ratePerUnit": 15,
                "totalCost": 60,
                "medicationDescription": "Metformin is used to control blood sugar levels in type 2 diabetes.",
                "company": "Merck",
                "tags": ["diabetes", "blood sugar control"],
                "shortage": false
              }
            ]
          },
          {
            "patientId": "P005",
            "patientName": "Martha Black",
            "dob": "1965-04-10",
            "age": 59,
            "gender": "Female",
            "diagnosis": "Chronic Obstructive Pulmonary Disease (COPD)",
            "admissionDate": "2024-11-28",
            "dischargeDate": "2024-11-30",
            "medications": [
              {
                "medicationName": "Ipratropium",
                "prescribedQuantity": 2,
                "consumedQuantity": 2,
                "issueQuantity": 2,
                "batchNumber": "D890",
                "expiryDate": "2025-05-05",
                "ratePerUnit": 30,
                "totalCost": 60,
                "medicationDescription": "Ipratropium is an anticholinergic used to treat COPD symptoms.",
                "company": "Boehringer Ingelheim",
                "tags": ["COPD", "respiratory"],
                "shortage": false
              }
            ]
          }
        ]
      },
    {
        wardName: 'Oncology',
        location: 'South Wing, 1st Floor',
        headDoctor: 'Dr. Anthony Richards',
        
      logo: cancer,
        requestDockerNo: "D12345",
        issueDate: "2024-11-25",
        requestDate: "2024-11-25",
        staff: [
            { name: 'Dr. Victoria Adams', role: 'Oncologist' },
            { name: 'Nurse Clara Haines', role: 'Oncology Nurse' },
            { name: 'Technician Brian Cooper', role: 'Radiology Technician' }
        ],
        medicines: [
            { name: 'Methotrexate', stockLevel: 0, issueQuantity: 2, batchNumber: 'O123', expiryDate: '2027-05-22', ratePerUnit: 55, cost: 110 },
            { name: 'Cyclophosphamide', stockLevel: 1, issueQuantity: 1, batchNumber: 'P456', expiryDate: '2026-10-10', ratePerUnit: 60, cost: 60 },
            { name: 'Doxorubicin', stockLevel: 3, issueQuantity: 3, batchNumber: 'Q789', expiryDate: '2026-06-15', ratePerUnit: 80, cost: 240 },
            { name: 'Paclitaxel', stockLevel: 0, issueQuantity: 0, batchNumber: 'R321', expiryDate: '2025-11-01', ratePerUnit: 120, cost: 0 },
            { name: 'Tamoxifen', stockLevel: 1, issueQuantity: 1, batchNumber: 'S654', expiryDate: '2027-02-20', ratePerUnit: 40, cost: 40 },
            { name: 'Capecitabine', stockLevel: 2, issueQuantity: 2, batchNumber: 'T987', expiryDate: '2026-07-05', ratePerUnit: 100, cost: 200 },
            { name: 'Bevacizumab', stockLevel: 0, issueQuantity: 0, batchNumber: 'U123', expiryDate: '2025-09-19', ratePerUnit: 150, cost: 0 },
        ],
        inventory: [
            {
                name: 'Methotrexate',
                stockLevel: 0,
                batchNumber: 'O123',
                expiryDate: '2027-05-22',
                ratePerUnit: 55,
                cost: 110,
                description: 'Methotrexate is used to treat various types of cancer and autoimmune diseases.',
                company: 'Pfizer',
                tags: ['cancer', 'autoimmune']
            },
            {
                name: 'Cyclophosphamide',
                stockLevel: 1,
                batchNumber: 'P456',
                expiryDate: '2026-10-10',
                ratePerUnit: 60,
                cost: 60,
                description: 'Cyclophosphamide is used to treat different types of cancer and autoimmune disorders.',
                company: 'Bristol-Myers Squibb',
                tags: ['cancer', 'autoimmune']
            },
            {
                name: 'Doxorubicin',
                stockLevel: 3,
                batchNumber: 'Q789',
                expiryDate: '2026-06-15',
                ratePerUnit: 80,
                cost: 240,
                description: 'Doxorubicin is used to treat various cancers, including breast cancer, leukemia, and others.',
                company: 'Johnson & Johnson',
                tags: ['cancer', 'breast cancer', 'leukemia']
            },
            {
                name: 'Paclitaxel',
                stockLevel: 0,
                batchNumber: 'R321',
                expiryDate: '2025-11-01',
                ratePerUnit: 120,
                cost: 0,
                description: 'Paclitaxel is used to treat ovarian, breast, lung, and other cancers.',
                company: 'Bayer',
                tags: ['cancer', 'ovarian cancer', 'breast cancer']
            },
            {
                name: 'Tamoxifen',
                stockLevel: 1,
                batchNumber: 'S654',
                expiryDate: '2027-02-20',
                ratePerUnit: 40,
                cost: 40,
                description: 'Tamoxifen is used to treat breast cancer and reduce the risk of breast cancer recurrence.',
                company: 'AstraZeneca',
                tags: ['breast cancer', 'hormone therapy']
            },
            {
                name: 'Capecitabine',
                stockLevel: 2,
                batchNumber: 'T987',
                expiryDate: '2026-07-05',
                ratePerUnit: 100,
                cost: 200,
                description: 'Capecitabine is used to treat breast, colorectal, and gastric cancers.',
                company: 'Roche',
                tags: ['breast cancer', 'colorectal cancer', 'gastric cancer']
            },
            {
                name: 'Bevacizumab',
                stockLevel: 0,
                batchNumber: 'U123',
                expiryDate: '2025-09-19',
                ratePerUnit: 150,
                cost: 0,
                description: 'Bevacizumab is used to treat various cancers, including colorectal cancer and lung cancer.',
                company: 'Genentech',
                tags: ['cancer', 'colorectal cancer', 'lung cancer']
            },
            {
                name: 'Lapatinib',
                stockLevel: 15,
                batchNumber: 'V456',
                expiryDate: '2026-12-20',
                ratePerUnit: 100,
                cost: 1500,
                description: 'Lapatinib is used to treat breast cancer and other cancers.',
                company: 'GlaxoSmithKline',
                tags: ['breast cancer', 'targeted therapy']
            },
            {
                name: 'Erlotinib',
                stockLevel: 18,
                batchNumber: 'W789',
                expiryDate: '2027-03-15',
                ratePerUnit: 120,
                cost: 2160,
                description: 'Erlotinib is used to treat non-small cell lung cancer and pancreatic cancer.',
                company: 'Roche',
                tags: ['lung cancer', 'pancreatic cancer']
            },
            {
                name: 'Trastuzumab',
                stockLevel: 24,
                batchNumber: 'X012',
                expiryDate: '2026-09-05',
                ratePerUnit: 200,
                cost: 4800,
                description: 'Trastuzumab is used to treat HER2-positive breast cancer and stomach cancer.',
                company: 'Genentech',
                tags: ['breast cancer', 'stomach cancer', 'HER2-positive']
            },
        ],

        DrugConsumption : 
        [ 
          {
          
            "patientId": "P001",
            "patientName": "John Doe",
            "dob": "1985-06-15",
            "age": 39,
            "gender": "Male",
            "diagnosis": "Hypertension, High Cholesterol",
            "admissionDate": "2024-11-01",
            "dischargeDate": "2024-11-15",
            "medications": [
              {
                "medicationName": "Aspirin",
                "prescribedQuantity": 2,
                "consumedQuantity": 2,
                "issueQuantity": 2,
                "batchNumber": "A123",
                "expiryDate": "2026-06-12",
                "ratePerUnit": 20,
                "totalCost": 40,
                "medicationDescription": "Aspirin is used to reduce fever, pain, and inflammation.",
                "company": "Bayer",
                "tags": ["pain", "fever", "inflammation"],
                "shortage": true
              },
              {
                "medicationName": "Atorvastatin",
                "prescribedQuantity": 1,
                "consumedQuantity": 1,
                "issueQuantity": 1,
                "batchNumber": "B456",
                "expiryDate": "2025-08-15",
                "ratePerUnit": 35,
                "totalCost": 35,
                "medicationDescription": "Atorvastatin is used to lower cholesterol and triglyceride levels.",
                "company": "Pfizer",
                "tags": ["cholesterol", "heart disease"],
                "shortage": false
              },
              {
                "medicationName": "Metoprolol",
                "prescribedQuantity": 2,
                "consumedQuantity": 2,
                "issueQuantity": 2,
                "batchNumber": "F987",
                "expiryDate": "2025-12-10",
                "ratePerUnit": 25,
                "totalCost": 50,
                "medicationDescription": "Metoprolol is a beta-blocker used to treat high blood pressure.",
                "company": "AstraZeneca",
                "tags": ["blood pressure", "heart attack prevention"],
                "shortage": false
              }
            ]
          },
          
          {
            "patientId": "P002",
            "patientName": "Jane Smith",
            "dob": "1970-03-20",
            "age": 54,
            "gender": "Female",
            "diagnosis": "Heart Failure",
            "admissionDate": "2024-11-10",
            "dischargeDate": "2024-11-20",
            "medications": [
              {
                "medicationName": "Furosemide",
                "prescribedQuantity": 3,
                "consumedQuantity": 3,
                "issueQuantity": 1,
                "batchNumber": "E654",
                "expiryDate": "2026-09-25",
                "ratePerUnit": 10,
                "totalCost": 30,
                "medicationDescription": "Furosemide is a diuretic used to treat fluid retention and swelling.",
                "company": "Lilly",
                "tags": ["diuretic", "fluid retention"],
                "shortage": true
              },
              {
                "medicationName": "Lisinopril",
                "prescribedQuantity": 2,
                "consumedQuantity": 2,
                "issueQuantity": 0,
                "batchNumber": "D321",
                "expiryDate": "2025-07-01",
                "ratePerUnit": 18,
                "totalCost": 36,
                "medicationDescription": "Lisinopril is an ACE inhibitor used to treat high blood pressure.",
                "company": "Merck",
                "tags": ["blood pressure", "heart failure"],
                "shortage": true
              }
            ]
          },
          {
            "patientId": "P003",
            "patientName": "Alice Brown",
            "dob": "1992-09-05",
            "age": 32,
            "gender": "Female",
            "diagnosis": "Asthma",
            "admissionDate": "2024-11-05",
            "dischargeDate": "2024-11-20",
            "medications": [
              {
                "medicationName": "Albuterol",
                "prescribedQuantity": 4,
                "consumedQuantity": 4,
                "issueQuantity": 4,
                "batchNumber": "A123",
                "expiryDate": "2026-04-15",
                "ratePerUnit": 10,
                "totalCost": 40,
                "medicationDescription": "Albuterol is a bronchodilator used to relieve symptoms of asthma.",
                "company": "GlaxoSmithKline",
                "tags": ["asthma", "bronchodilator"],
                "shortage": false
              },
              {
                "medicationName": "Prednisone",
                "prescribedQuantity": 3,
                "consumedQuantity": 3,
                "issueQuantity": 3,
                "batchNumber": "B234",
                "expiryDate": "2025-12-01",
                "ratePerUnit": 5,
                "totalCost": 15,
                "medicationDescription": "Prednisone is a corticosteroid used to reduce inflammation.",
                "company": "Bristol-Myers",
                "tags": ["inflammation", "steroid"],
                "shortage": true
              }
            ]
          },
          
          // New patient P004 (Admitted on 2024-11-12, discharged on 2024-11-18)
          {
            "patientId": "P004",
            "patientName": "Robert Green",
            "dob": "1980-12-22",
            "age": 43,
            "gender": "Male",
            "diagnosis": "Diabetes",
            "admissionDate": "2024-11-12",
            "dischargeDate": "2024-11-18",
            "medications": [
              {
                "medicationName": "Metformin",
                "prescribedQuantity": 4,
                "consumedQuantity": 4,
                "issueQuantity": 4,
                "batchNumber": "C567",
                "expiryDate": "2025-09-30",
                "ratePerUnit": 15,
                "totalCost": 60,
                "medicationDescription": "Metformin is used to control blood sugar levels in type 2 diabetes.",
                "company": "Merck",
                "tags": ["diabetes", "blood sugar control"],
                "shortage": false
              }
            ]
          },
          {
            "patientId": "P005",
            "patientName": "Martha Black",
            "dob": "1965-04-10",
            "age": 59,
            "gender": "Female",
            "diagnosis": "Chronic Obstructive Pulmonary Disease (COPD)",
            "admissionDate": "2024-11-28",
            "dischargeDate": "2024-11-30",
            "medications": [
              {
                "medicationName": "Ipratropium",
                "prescribedQuantity": 2,
                "consumedQuantity": 2,
                "issueQuantity": 2,
                "batchNumber": "D890",
                "expiryDate": "2025-05-05",
                "ratePerUnit": 30,
                "totalCost": 60,
                "medicationDescription": "Ipratropium is an anticholinergic used to treat COPD symptoms.",
                "company": "Boehringer Ingelheim",
                "tags": ["COPD", "respiratory"],
                "shortage": false
              }
            ]
          }
        ]
      },
        {
        wardName: 'Pediatrics',
        location: 'West Wing, 2nd Floor',
        headDoctor: 'Dr. Emily Green',
        
      logo: baby,
        requestDockerNo: "D12345",
        issueDate: "2024-11-25",
        requestDate: "2024-11-25",
        staff: [
            { name: 'Dr. Alice Brown', role: 'Pediatrician' },
            { name: 'Nurse Lily Cooper', role: 'Pediatric Nurse' },
            { name: 'Technician Sarah Miller', role: 'Pediatric Technician' }
        ],
        medicines: [
            { name: 'Amoxicillin', stockLevel: 0, issueQuantity: 5, batchNumber: 'P123', expiryDate: '2026-12-05', ratePerUnit: 15, cost: 75 },
            { name: 'Ibuprofen', stockLevel: 2, issueQuantity: 2, batchNumber: 'Q456', expiryDate: '2027-04-10', ratePerUnit: 8, cost: 16 },
            { name: 'Paracetamol', stockLevel: 3, issueQuantity: 2, batchNumber: 'R789', expiryDate: '2026-11-22', ratePerUnit: 10, cost: 20 },
            { name: 'Diphenhydramine', stockLevel: 0, issueQuantity: 1, batchNumber: 'S321', expiryDate: '2025-09-30', ratePerUnit: 12, cost: 12 },
            { name: 'Salbutamol', stockLevel: 4, issueQuantity: 4, batchNumber: 'T654', expiryDate: '2027-02-10', ratePerUnit: 18, cost: 72 },
            { name: 'Cetirizine', stockLevel: 0, issueQuantity: 0, batchNumber: 'U987', expiryDate: '2026-07-17', ratePerUnit: 5, cost: 0 },
            { name: 'Loratadine', stockLevel: 2, issueQuantity: 2, batchNumber: 'V123', expiryDate: '2026-03-15', ratePerUnit: 6, cost: 12 },
        ],
        inventory: [
            {
                name: 'Amoxicillin',
                stockLevel: 0,
                batchNumber: 'P123',
                expiryDate: '2026-12-05',
                ratePerUnit: 15,
                cost: 75,
                description: 'Amoxicillin is an antibiotic used to treat bacterial infections.',
                company: 'GlaxoSmithKline',
                tags: ['antibiotic', 'bacterial infections']
            },
            {
                name: 'Ibuprofen',
                stockLevel: 2,
                batchNumber: 'Q456',
                expiryDate: '2027-04-10',
                ratePerUnit: 8,
                cost: 16,
                description: 'Ibuprofen is used to reduce fever, pain, and inflammation.',
                company: 'Pfizer',
                tags: ['pain', 'fever', 'inflammation']
            },
            {
                name: 'Paracetamol',
                stockLevel: 3,
                batchNumber: 'R789',
                expiryDate: '2026-11-22',
                ratePerUnit: 10,
                cost: 20,
                description: 'Paracetamol is used to treat mild to moderate pain and reduce fever.',
                company: 'Johnson & Johnson',
                tags: ['pain', 'fever']
            },
            {
                name: 'Diphenhydramine',
                stockLevel: 0,
                batchNumber: 'S321',
                expiryDate: '2025-09-30',
                ratePerUnit: 12,
                cost: 12,
                description: 'Diphenhydramine is used to relieve allergy symptoms and as a short-term sleep aid.',
                company: 'Bristol-Myers Squibb',
                tags: ['allergy', 'sleep aid']
            },
            {
                name: 'Salbutamol',
                stockLevel: 4,
                batchNumber: 'T654',
                expiryDate: '2027-02-10',
                ratePerUnit: 18,
                cost: 72,
                description: 'Salbutamol is used to treat asthma and chronic obstructive pulmonary disease (COPD).',
                company: 'AstraZeneca',
                tags: ['asthma', 'COPD']
            },
            {
                name: 'Cetirizine',
                stockLevel: 0,
                batchNumber: 'U987',
                expiryDate: '2026-07-17',
                ratePerUnit: 5,
                cost: 0,
                description: 'Cetirizine is used to relieve allergy symptoms such as a runny nose, sneezing, and itchy eyes.',
                company: 'Merck',
                tags: ['allergy']
            },
            {
                name: 'Loratadine',
                stockLevel: 2,
                batchNumber: 'V123',
                expiryDate: '2026-03-15',
                ratePerUnit: 6,
                cost: 12,
                description: 'Loratadine is used to treat allergy symptoms and itching caused by hives.',
                company: 'Pfizer',
                tags: ['allergy', 'hives']
            },
            {
                name: 'Prednisolone',
                stockLevel: 10,
                batchNumber: 'W456',
                expiryDate: '2026-09-05',
                ratePerUnit: 25,
                cost: 250,
                description: 'Prednisolone is a corticosteroid used to reduce inflammation and treat various conditions.',
                company: 'Bayer',
                tags: ['corticosteroid', 'inflammation']
            },
            {
                name: 'Omeprazole',
                stockLevel: 15,
                batchNumber: 'X789',
                expiryDate: '2027-01-12',
                ratePerUnit: 40,
                cost: 600,
                description: 'Omeprazole is used to treat acid reflux, ulcers, and other stomach issues.',
                company: 'Novartis',
                tags: ['stomach', 'acid reflux', 'ulcers']
            },
            {
                name: 'Cefalexin',
                stockLevel: 20,
                batchNumber: 'Y012',
                expiryDate: '2026-05-20',
                ratePerUnit: 12,
                cost: 240,
                description: 'Cefalexin is an antibiotic used to treat bacterial infections.',
                company: 'GlaxoSmithKline',
                tags: ['antibiotic', 'bacterial infections']
            },
        ],
        
        DrugConsumption : 
        [ 
          {
          
            "patientId": "P001",
            "patientName": "John Doe",
            "dob": "1985-06-15",
            "age": 39,
            "gender": "Male",
            "diagnosis": "Hypertension, High Cholesterol",
            "admissionDate": "2024-11-01",
            "dischargeDate": "2024-11-15",
            "medications": [
              {
                "medicationName": "Aspirin",
                "prescribedQuantity": 2,
                "consumedQuantity": 2,
                "issueQuantity": 2,
                "batchNumber": "A123",
                "expiryDate": "2026-06-12",
                "ratePerUnit": 20,
                "totalCost": 40,
                "medicationDescription": "Aspirin is used to reduce fever, pain, and inflammation.",
                "company": "Bayer",
                "tags": ["pain", "fever", "inflammation"],
                "shortage": true
              },
              {
                "medicationName": "Atorvastatin",
                "prescribedQuantity": 1,
                "consumedQuantity": 1,
                "issueQuantity": 1,
                "batchNumber": "B456",
                "expiryDate": "2025-08-15",
                "ratePerUnit": 35,
                "totalCost": 35,
                "medicationDescription": "Atorvastatin is used to lower cholesterol and triglyceride levels.",
                "company": "Pfizer",
                "tags": ["cholesterol", "heart disease"],
                "shortage": false
              },
              {
                "medicationName": "Metoprolol",
                "prescribedQuantity": 2,
                "consumedQuantity": 2,
                "issueQuantity": 2,
                "batchNumber": "F987",
                "expiryDate": "2025-12-10",
                "ratePerUnit": 25,
                "totalCost": 50,
                "medicationDescription": "Metoprolol is a beta-blocker used to treat high blood pressure.",
                "company": "AstraZeneca",
                "tags": ["blood pressure", "heart attack prevention"],
                "shortage": false
              }
            ]
          },
          
          {
            "patientId": "P002",
            "patientName": "Jane Smith",
            "dob": "1970-03-20",
            "age": 54,
            "gender": "Female",
            "diagnosis": "Heart Failure",
            "admissionDate": "2024-11-10",
            "dischargeDate": "2024-11-20",
            "medications": [
              {
                "medicationName": "Furosemide",
                "prescribedQuantity": 3,
                "consumedQuantity": 3,
                "issueQuantity": 1,
                "batchNumber": "E654",
                "expiryDate": "2026-09-25",
                "ratePerUnit": 10,
                "totalCost": 30,
                "medicationDescription": "Furosemide is a diuretic used to treat fluid retention and swelling.",
                "company": "Lilly",
                "tags": ["diuretic", "fluid retention"],
                "shortage": true
              },
              {
                "medicationName": "Lisinopril",
                "prescribedQuantity": 2,
                "consumedQuantity": 2,
                "issueQuantity": 0,
                "batchNumber": "D321",
                "expiryDate": "2025-07-01",
                "ratePerUnit": 18,
                "totalCost": 36,
                "medicationDescription": "Lisinopril is an ACE inhibitor used to treat high blood pressure.",
                "company": "Merck",
                "tags": ["blood pressure", "heart failure"],
                "shortage": true
              }
            ]
          },
          {
            "patientId": "P003",
            "patientName": "Alice Brown",
            "dob": "1992-09-05",
            "age": 32,
            "gender": "Female",
            "diagnosis": "Asthma",
            "admissionDate": "2024-11-05",
            "dischargeDate": "2024-11-20",
            "medications": [
              {
                "medicationName": "Albuterol",
                "prescribedQuantity": 4,
                "consumedQuantity": 4,
                "issueQuantity": 4,
                "batchNumber": "A123",
                "expiryDate": "2026-04-15",
                "ratePerUnit": 10,
                "totalCost": 40,
                "medicationDescription": "Albuterol is a bronchodilator used to relieve symptoms of asthma.",
                "company": "GlaxoSmithKline",
                "tags": ["asthma", "bronchodilator"],
                "shortage": false
              },
              {
                "medicationName": "Prednisone",
                "prescribedQuantity": 3,
                "consumedQuantity": 3,
                "issueQuantity": 3,
                "batchNumber": "B234",
                "expiryDate": "2025-12-01",
                "ratePerUnit": 5,
                "totalCost": 15,
                "medicationDescription": "Prednisone is a corticosteroid used to reduce inflammation.",
                "company": "Bristol-Myers",
                "tags": ["inflammation", "steroid"],
                "shortage": true
              }
            ]
          },
          
          // New patient P004 (Admitted on 2024-11-12, discharged on 2024-11-18)
          {
            "patientId": "P004",
            "patientName": "Robert Green",
            "dob": "1980-12-22",
            "age": 43,
            "gender": "Male",
            "diagnosis": "Diabetes",
            "admissionDate": "2024-11-12",
            "dischargeDate": "2024-11-18",
            "medications": [
              {
                "medicationName": "Metformin",
                "prescribedQuantity": 4,
                "consumedQuantity": 4,
                "issueQuantity": 4,
                "batchNumber": "C567",
                "expiryDate": "2025-09-30",
                "ratePerUnit": 15,
                "totalCost": 60,
                "medicationDescription": "Metformin is used to control blood sugar levels in type 2 diabetes.",
                "company": "Merck",
                "tags": ["diabetes", "blood sugar control"],
                "shortage": false
              }
            ]
          },
          {
            "patientId": "P005",
            "patientName": "Martha Black",
            "dob": "1965-04-10",
            "age": 59,
            "gender": "Female",
            "diagnosis": "Chronic Obstructive Pulmonary Disease (COPD)",
            "admissionDate": "2024-11-28",
            "dischargeDate": "2024-11-30",
            "medications": [
              {
                "medicationName": "Ipratropium",
                "prescribedQuantity": 2,
                "consumedQuantity": 2,
                "issueQuantity": 2,
                "batchNumber": "D890",
                "expiryDate": "2025-05-05",
                "ratePerUnit": 30,
                "totalCost": 60,
                "medicationDescription": "Ipratropium is an anticholinergic used to treat COPD symptoms.",
                "company": "Boehringer Ingelheim",
                "tags": ["COPD", "respiratory"],
                "shortage": false
              }
            ]
          }
        ]

        
    },

    


];

